module.exports = __webpack_public_path__ + "static/media/hall-AF.28d679da.svg";